import api from "./api";

export async function getInstitutions() {
  try {
    const response = await api.get(
      `api/institutions`
    );
    return response.data;
  } catch (error) {
    return [];
  }
}
